import React from 'react'
import Session from '../Session'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import CurrentUserQuery from 'graphs/queries/CurrentUser.graphql'

const CurrentUserProvider = ({ children }) => (
  <Session
    render={({ isAuthenticated }) =>
      isAuthenticated ? (
        <Query query={CurrentUserQuery}>
          {({ loading, data }) => (
            <Broadcast
              channel="currentUser"
              value={{
                loading,
                viewer: !loading &&
                  data && {
                    userServers: clientId =>
                      data.viewer &&
                      data.viewer.servers.edges.reduce(
                        (acc, { node: server }) => {
                          if (
                            !clientId ||
                            server.product.client_id === clientId
                          ) {
                            return [...acc, server]
                          }
                          return acc
                        },
                        []
                      ),
                    ...data.viewer
                  }
              }}
            >
              {children}
            </Broadcast>
          )}
        </Query>
      ) : (
        <Broadcast channel="currentUser" value={{ loading: false }}>
          {children}
        </Broadcast>
      )
    }
  />
)

export default CurrentUserProvider



// WEBPACK FOOTER //
// ./src/components/CurrentUser/Provider.js